import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FormsModule } from "@angular/forms";

import { MatGridListModule } from '@angular/material/grid-list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';

import { AgGridModule } from 'ag-grid-angular';

@Component({
    selector: 'app-preview-report',
    templateUrl: './preview-report.component.html',
    styleUrls: ['./preview-report.component.css'],
    standalone: true,
    imports: [
      FormsModule,
      AgGridModule,
      MatGridListModule,
      MatDatepickerModule,
      MatFormFieldModule,
      MatSidenavModule,
      MatDividerModule,
    ]
  })
export class PreviewReportComponent implements OnInit {

  gridApi: any;

  currentReportPreviewDataList = [];
  selectedCurrentReportColumns: any;

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  constructor(@Inject(MAT_DIALOG_DATA) data) { 

    this.currentReportPreviewDataList = data.reportPreview;
    this.selectedCurrentReportColumns = data.selectedCurrentReportColumns;


  }

  ngOnInit(): void {

    // console.log('preview report: ', this.currentReportPreviewDataList);
    // console.log('columns: ', this.selectedCurrentReportColumns);


  }


  gridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }  

}
